import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ingredient-uom-info-popover',
  templateUrl: './ingredient-uom-info-popover.component.html',
  styleUrls: [
    './ingredient-uom-info-popover.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientUomInfoPopoverComponent {
  @Input() alternative = false;
  @Input() forRecipe = false;
  constructor() {}
}
